import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { makeStyles, MenuList, Typography } from '@material-ui/core';
import clsx from 'clsx';
import { useEffect, useRef } from 'react';
import { For } from 'react-loops';
import { appHeaderHeight, transitionSpeed } from '../../theme';
import { AppSwitcherLink } from './AppSwitcherLink/AppSwitcherLink';
import { AppSwitcherTitles } from './constants';
const useStyles = makeStyles((theme) => ({
    categoryHeader: {
        fontWeight: 500,
        padding: theme.spacing(1, 0, 0),
        textTransform: 'uppercase',
    },
    drawerFloat: {
        backgroundColor: theme.palette.common.white,
        boxSizing: 'border-box',
        height: `calc(100vh - ${appHeaderHeight}px)`,
        left: 0,
        opacity: 0,
        overflowY: 'auto',
        padding: theme.spacing(3, 2, 0),
        position: 'absolute',
        top: appHeaderHeight,
        transform: 'translateX(-100%)',
        transition: `opacity ${transitionSpeed} ease-out, transform ${transitionSpeed} ease-out, box-shadow ${transitionSpeed} ease-out`,
        width: 400,
    },
    drawerFloatVisible: {
        boxShadow: `0 1px 14px 0 rgba(0, 0, 0, 0.12), 0 5px 8px 0 rgba(0, 0, 0, 0.14), 0 3px 5px -1px rgba(0, 0, 0, 0.20)`,
        opacity: 1,
        transform: 'translateX(0)',
        zIndex: 1500,
    },
}));
/**
 * Component to display external navigation links.
 *
 * @param {NavigationLink[]} props.links - The array of navigation links.
 * @param {boolean} props.visible - Indicates whether the `AppSwitcher` is visible or not.
 * @returns {JSX.Element} The rendered `AppSwitcher` component.
 */
export function AppSwitcher({ links, visible, setVisible }) {
    const classes = useStyles();
    const menuRef = useRef(null);
    const groupedNavigation = links.reduce((pv, cv) => {
        if (!pv[cv.category]) {
            pv[cv.category] = [];
        }
        if (cv && pv[cv.category]) {
            pv[cv.category]?.push(cv);
        }
        return pv;
    }, {});
    useEffect(() => {
        const handleClickOutside = (e) => {
            const target = e.target;
            const isOutsideClick = menuRef.current && !menuRef.current.contains(target);
            const isNotAppSwitcherButton = target.getAttribute('data-testid') !== 'appswitcher-button';
            if (isOutsideClick && isNotAppSwitcherButton && visible) {
                setVisible(false);
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [visible, setVisible]);
    return (_jsx("nav", { className: clsx(classes.drawerFloat, { [classes.drawerFloatVisible]: visible }), ref: menuRef, children: _jsx(For, { of: Object.entries(groupedNavigation), as: ([category, links]) => (_jsxs(_Fragment, { children: [_jsx(Typography, { className: classes.categoryHeader, color: 'primary', children: AppSwitcherTitles[+category] }), _jsx(MenuList, { children: _jsx(For, { of: links, as: (link) => _jsx(AppSwitcherLink, { ...link }) }) })] })) }) }));
}
